<template>
  <div class="footer">
    <div><a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备17070040号-1</a>&nbsp;© &nbsp; All rights reserved 南京水晶视界数字科技有限公司</div>
  </div>
</template>
<style scoped>

a {
    color: inherit;
    text-decoration: none;
}
.footer {
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: row;
  position: absolute;
  /* bottom: 0; */
  padding: 0px 40px;
  background-color: rgb(51, 51, 51);
  font-size: 12px;
  color: rgb(255, 255, 255);
}
.back-home{
  display: flex;
}

.back-home img{
  width: 14px;
    height: 14px;
    margin-right: 5px;
}

</style>
<script>
export default {
  name: "top",
  props: {
    
  },
  data() {
    return {
    };
  },
  mounted() {
   
  }
};
</script>
